import { FC } from "react";
import styles from "./style.scss";

export const Divider: FC = () => <div className={styles.divider} />;
